import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { findDOMNode } from 'react-dom';
import { createObserver, observeElement, unobserveElement } from './observer';
import { shallowCompare } from './utils';
import Config from './config';
var observerOptions = ['root', 'rootMargin', 'threshold'];
var observableProps = ['root', 'rootMargin', 'threshold', 'disabled'];
var _Object$prototype = Object.prototype,
    hasOwnProperty = _Object$prototype.hasOwnProperty,
    toString = _Object$prototype.toString;

var getOptions = function getOptions(props) {
  return observerOptions.reduce(function (options, key) {
    if (hasOwnProperty.call(props, key)) {
      var rootIsString = key === 'root' && toString.call(props[key]) === '[object String]';
      options[key] = rootIsString ? document.querySelector(props[key]) : props[key];
    }

    return options;
  }, {});
};

var IntersectionObserver = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(IntersectionObserver, _React$Component);

  function IntersectionObserver() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(event, _this.externalUnobserve);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNode", function (target) {
      var children = _this.props.children;

      if (children != null) {
        /**
         * Forward hijacked ref to user.
         */
        var nodeRef = children.ref;

        if (nodeRef) {
          if (typeof nodeRef === 'function') {
            nodeRef(target);
          } else if (typeof nodeRef === 'object') {
            nodeRef.current = target;
          }
        }
      }

      _this.targetNode = target && findDOMNode(target);
    });

    _defineProperty(_assertThisInitialized(_this), "observe", function () {
      if (_this.props.children == null || _this.props.disabled) {
        return false;
      }

      if (!_this.targetNode) {
        Config.errorReporter("ReactIntersectionObserver: Can't find DOM node in the provided children. Make sure to render at least one DOM node in the tree.");
        return false;
      }

      _this.observer = createObserver(getOptions(_this.props));
      _this.target = _this.targetNode;
      observeElement(_assertThisInitialized(_this));
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "unobserve", function (target) {
      unobserveElement(_assertThisInitialized(_this), target);
    });

    _defineProperty(_assertThisInitialized(_this), "externalUnobserve", function () {
      _this.unobserve(_this.targetNode);
    });

    return _this;
  }

  var _proto = IntersectionObserver.prototype;

  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
    var _this2 = this;

    this.prevTargetNode = this.targetNode;
    var relatedPropsChanged = observableProps.some(function (prop) {
      return shallowCompare(_this2.props[prop], prevProps[prop]);
    });

    if (relatedPropsChanged) {
      if (this.prevTargetNode) {
        if (!prevProps.disabled) {
          this.unobserve(this.prevTargetNode);
        }
      }
    }

    return relatedPropsChanged;
  };

  _proto.componentDidUpdate = function componentDidUpdate(_, __, relatedPropsChanged) {
    var targetNodeChanged = false; // check if we didn't unobserve previously due to a prop change

    if (!relatedPropsChanged) {
      targetNodeChanged = this.prevTargetNode !== this.targetNode; // check we have a previous node we want to unobserve

      if (targetNodeChanged && this.prevTargetNode != null) {
        this.unobserve(this.prevTargetNode);
      }
    }

    if (relatedPropsChanged || targetNodeChanged) {
      this.observe();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.observe();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.targetNode) {
      this.unobserve(this.targetNode);
    }
  };

  _proto.render = function render() {
    var children = this.props.children;
    return children != null ? React.cloneElement(React.Children.only(children), {
      ref: this.handleNode
    }) : null;
  };

  return IntersectionObserver;
}(React.Component);

_defineProperty(IntersectionObserver, "displayName", 'IntersectionObserver');

process.env.NODE_ENV !== "production" ? void 0 : void 0;
export { IntersectionObserver as default, getOptions };